class StickyProduct extends HTMLElement {
  constructor() {
    super();

    this.stickySelect = document.querySelector('.block-sticky__act');
  }

  connectedCallback() {

    let self = this;
    const footerElement = document.querySelector('footer');
    this.addEventListener("click", (e) => this.handleButtonClick(e));

    window.addEventListener("scroll", function (e) {
      let rect = self.stickySelect.getBoundingClientRect();
      if (rect.top < 0 && !isElementInViewport(footerElement)) {
        document.querySelector('.block-sticky__act').classList.add("active");
      }else{
        document.querySelector('.block-sticky__act').classList.remove("active");
      }

      // Function to check if an element is in the viewport
      function isElementInViewport(el) {
        // Get the bounding rectangle of the element
        var rect = el.getBoundingClientRect();

        // Check if the element is within the viewport
        return (
            rect.top >= 0 && // Element top is above the bottom of the viewport
            rect.left >= 0 && // Element left is to the right of the left edge of the viewport
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && // Element bottom is below the top of the viewport
            rect.right <= (window.innerWidth || document.documentElement.clientWidth) // Element right is to the left of the right edge of the viewport
        );
      }

      function isElementPartiallyInViewport(el) {
          var rect = el.getBoundingClientRect();
          return (
              rect.top < window.innerHeight && // Element top is below the top of the viewport
              rect.left < window.innerWidth && // Element left is to the left of the right edge of the viewport
              rect.bottom >= 0 && // Element bottom is above the bottom of the viewport
              rect.right >= 0 // Element right is to the right of the left edge of the viewport
          );
      }

    });
  }

  handleButtonClick(e) {
    if (e.target.closest(".button-product__sticky")) {
      const stickyButton = e.target.closest(".button-product__sticky");

      stickyButton.classList.add("loading");
      stickyButton.querySelector(".loading__spinner")?.classList.remove("hidden");

      document.querySelector('[id^="ProductSubmitButton-"]')?.click();
    }
  }
}
customElements.define("sticky-product", StickyProduct);
